import { AudioKeyTemplate } from "@Animation/constants";

export enum KENO_SNAKES_ATLAS_FRAMES {
  GRID_BACKGROUND = 'grid-background.png',
  PARTICLE_TRAIL = 'particle-trail-circle.png',
  PROJECTILE_1 = 'projectile-1.png',
  PROJECTILE_2 = 'projectile-2.png',
  PULSE_0 = 'pulse-0.png',
  PULSE_1 = 'pulse-1.png',
  PULSE_2 = 'pulse-2.png',
  PULSE_3 = 'pulse-3.png',
  NUMBER_DEFAULT = 'numbers/default.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
  NUMBER_PLAYER_SELECTED = 'numbers/player-selected.png',
  NUMBER_HIT = 'numbers/match.png',
  NUMBER_GLOW = 'numbers/glow.png',
}

export enum KENO_SNAKES_TEXTURE_KEYS {
  ATLAS = 'KENO_SNAKES_DRAW_ANIMATION_ATLAS',
  NUMBER_DEFAULT = 'KENO_SNAKES_NUMBER_DEFAULT',
  NUMBER_SYSTEM_SELECTED = 'KENO_SNAKES_NUMBER_SYSTEM_SELECTED',
  NUMBER_PLAYER_SELECTED = 'KENO_SNAKES_NUMBER_PLAYER_SELECTED',
  NUMBER_HIT = 'KENO_SNAKES_NUMBER_HIT',
}

export const KENO_SNAKES_AUDIO_KEYS: AudioKeyTemplate = {
  BIG_WIN: 'big-win.wav',
  BONUS_CHOSEN: 'bonus-chosen.wav',
  BONUS_ELIMINATED: 'bonus-eliminated.wav',
  MATCH: 'match.wav',
  NO_BONUS: 'no-bonus.wav',
  NO_MATCH: 'no-match.wav',
  SMALL_WIN: 'small-win.wav'
}